import { watchDebounced } from '@vueuse/core'
import { useRoute, useRouter } from 'vue-router'
import { cloneDeep, isEqual } from 'lodash'

const isEmpty = (val) => {
    if (val == null) return true
    if (Array.isArray(val)) return val.length === 0
    if (typeof val === 'object') return Object.keys(val).length === 0
    if (typeof val === 'string') return val.trim() === ''
    return false
}

const shouldIncludeInQuery = (val) => {
    if (val === 0) return false
    if (Array.isArray(val)) return true // Always include arrays, even if empty
    return !isEmpty(val)
}

export const useQuerySync = (source, options = {}) => {
    const router = useRouter()
    const route = useRoute()

    const { debounce = 300, keys = [] } = options

    const pickManaged = (query) => {
        return Object.fromEntries(keys.filter((key) => shouldIncludeInQuery(query[key])).map((key) => [key, cloneDeep(query[key])]))
    }

    const pickNextManaged = (value) => {
        return Object.fromEntries(keys.filter((key) => shouldIncludeInQuery(value[key])).map((key) => [key, cloneDeep(value[key])]))
    }

    watchDebounced(
        source,
        (value) => {
            if (!value || typeof value !== 'object') return

            const currentManaged = pickManaged(route.query)
            const nextManaged = pickNextManaged(value)

            if (isEqual(currentManaged, nextManaged)) return

            // start from existing query
            const nextQuery = cloneDeep(route.query)

            // remove managed keys first
            keys.forEach((key) => {
                delete nextQuery[key]
            })

            Object.assign(nextQuery, cloneDeep(nextManaged))

            router.replace({
                path: route.path,
                query: nextQuery
            })
        },
        {
            debounce,
            deep: true,
            flush: 'post'
        }
    )
}
